import { parseAddress } from 'hooks/useLocation';
import { useStatus as fetchStatus } from 'hooks/useStatus';
import { Account } from 'interfaces/Account';
import { Category } from 'interfaces/Category';
import { Reporter } from 'interfaces/Reporter';
import { Team } from 'interfaces/Team';
import { WorkOrder } from 'interfaces/WorkOrder';
import moment from 'moment';
import { Content } from 'pdfmake/interfaces';

export interface WorkOrderProps
  extends Pick<WorkOrder, 'createdAt' | 'titleDisplay' | 'location' | 'status'> {
  category: Pick<Category, 'name'>;
  assignee: Pick<Account, 'name'>;
  team: Pick<Team, 'name'>;
  reporter: Pick<Reporter, 'name'>;
}

export interface CreateContentConfig {
  workorders: WorkOrderProps[];
}

export const createContent = ({ workorders }: CreateContentConfig): Content[] => {
  return [
    { text: 'Work Orders', style: 'sectionHeader' },
    {
      style: 'verticalSpacingMd',
      fontSize: 8,
      table: {
        headerRows: 1,
        widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
        body: [
          [
            { text: 'Date', style: 'tableHeader' },
            { text: 'Title', style: 'tableHeader' },
            { text: 'Address', style: 'tableHeader' },
            { text: 'Status', style: 'tableHeader' },
            { text: 'Category', style: 'tableHeader' },
            { text: 'Assignee', style: 'tableHeader' },
            { text: 'Team', style: 'tableHeader' },
            { text: 'Resident', style: 'tableHeader' },
          ],
          ...workorders.map((workorder): Content[] => [
            moment(workorder.createdAt).format('MM/DD/YYYY'),
            workorder.titleDisplay,
            parseAddress(workorder.location?.address) || '',
            { text: fetchStatus(workorder.status).label, alignment: 'center' },
            { text: workorder.category?.name || '', alignment: 'center' },
            { text: workorder.assignee?.name || '', alignment: 'center' },
            { text: workorder.team?.name || '', alignment: 'center' },
            { text: workorder.reporter?.name || '', alignment: 'center' },
          ]),
        ],
      },
      layout: {
        hLineWidth: () => 0.5,
        hLineColor: (i, node) =>
          i === 0 || i === (node.table.headerRows || 1) || i === node.table.body.length
            ? '#000000'
            : '#CCCCCC',
        vLineWidth: (i, node) => (i === 0 || i === node.table.body[0].length ? 0.5 : 0),
        // Text is slightly high in cell if top and bottom match. Maybe from lineHeight.
        // Small offset to compensate and vertically center.
        paddingTop: () => 9,
        paddingBottom: () => 7,
        paddingLeft: () => 10,
        paddingRight: (i) => (i === 0 ? 0 : 10),
      },
    },
  ];
};
